export const Sort = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6H20" stroke="#1F1F1F" strokeWidth="1.875" strokeLinecap="square"/>
      <path d="M7 12H17" stroke="#1F1F1F" strokeWidth="1.875" strokeLinecap="square"/>
      <path d="M9.00049 18H15.0005" stroke="#1F1F1F" strokeWidth="1.875" strokeLinecap="square"/>
    </svg>
  );
};
